<script setup lang="ts">
import { computed } from "vue";
import { marked, type Tokens, type RendererObject } from "marked";
import DOMPurify from "dompurify";

export interface TcMarkdownRenderedProps {
  content: string;
}

export type RendererConfig = Pick<RendererObject, "link">;

const props = defineProps<TcMarkdownRenderedProps>();

const customRenderer: RendererConfig = {
  link(token: Tokens.Link): string {
    const title = token.title ? ` title="${token.title}"` : "";
    const innerHTML = marked.parser(token.tokens || []);

    return `<a href="${token.href}"${title} target="_blank" rel="noopener noreferrer">${innerHTML}</a>`;
  },
};

marked.use({ renderer: customRenderer });

const renderedMarkdown = computed((): string => {
  const rawHTML = marked(props.content) as string;
  const cleanHTML: string = DOMPurify.sanitize(rawHTML, {
    ALLOWED_ATTR: ["href", "title", "target", "rel"],
  });

  return cleanHTML;
});
</script>

<template>
  <div v-html="renderedMarkdown" class="tc_markdown" />
</template>

<style lang="scss">
.tc_markdown {
  ul,
  ol {
    @include sp.margin(l, 4);
  }
  ul {
    list-style-type: square;
  }
}
</style>
